<template>
  <component
    :is="iconComponent"
    :size="size"
    :stroke-width="strokeWidth"
    class="app-icon"
    :class="iconClass"
  />
</template>

<script>
import * as LucideIcons from "@lucide/vue";
import { resolveLucideIcon } from "@/utils/mdiLucideMap.js";

export default {
  name: "AppIcon",
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 17 },
    strokeWidth: { type: Number, default: 2 },
    iconClass: { type: String, default: "" },
  },
  computed: {
    iconComponent() {
      const lucideName = resolveLucideIcon(this.name);
      return LucideIcons[lucideName] || LucideIcons.CircleDot;
    },
  },
};
</script>

<style scoped>
.app-icon {
  flex-shrink: 0;
  display: inline-block;
  vertical-align: middle;
  color: currentColor;
}

.app-icon :deep(svg) {
  display: block;
}
</style>
